import { Component, Injectable, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'compatibility-popup',
  templateUrl: 'compatibility-popup.component.html',
  styleUrls: ['compatibility-popup.component.scss'],
  standalone: false
})
export class CompatibilityPopupComponent {
  constructor(public dialogRef: MatDialogRef<CompatibilityPopupComponent>) {}
}
